import React from 'react'

function InvoiceListInnerStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
        {`
          #table-invoice-list-inner-container {
            /*padding: 5px;*/
            border: solid 0.5px lightgrey;
            display: flex;
            flex-direction: column;
            justify-content: stretch;
            font-size: 0.65em;
          }

          /** modify parent class table style **/
          .table thead tr th:nth-child(7) {
            width: 2%;
            padding: 0;
          }
          .table tbody tr td:nth-child(7) {
            width: 2%;
            padding: 0;
          }

          .invoice-checkbox {
            margin-top: 11px;
            margin-left: 12px;
            /*margin-right: 10px;*/
          }

          .title-header {
            display: flex;
          }
          .title-header:hover {
            cursor: pointer;
          }
          .title-header div {
            flex: 2;
          }
          .title-header span {
            text-align: right;
          }

          .label-status {
            /*border: solid 1px #50A0F3;*/
            border-radius: 5px;
            padding: 3px 6px;
          }
          /*.label-status.Paid:before { content: 'check mark here'; }*/
          /* Label status styles */
          .label-status.Paid { color: whitesmoke; background-color: green; }
          .label-status.Unpaid { color: whitesmoke; background-color: red; }
          .label-status.Linked { color: whitesmoke; background-color: blue; }
          .label-status.OnProcess { color: green; background-color: yellow; }
          .label-status.Inactive { color: #808080; background-color: lightgrey; }

          /* font color per invoice status */
          .row-text-color.Inactive { color: lightgrey; }
          .row-text-color.OnProcess { color: green; }
        `}
      </style>
    </React.Fragment>
  )
}

export default React.memo(InvoiceListInnerStyle)
